
/** 
 * @typedef { Object } BannerState 
 * @property { boolean } modal
 * @property { boolean } isEmpty
*/

/** 
 * @typedef { Object } DefaultStateHomeModule 
 * @property { BannerState } banner
*/

/** 
 * @typedef { Object } StateHomeModule
 * @property { DefaultStateHomeModule } default
 */

/** @type { import('vuex').StoreOptions<StateHomeModule & BannerState> } */
export default {
  state: () => ({
    default: {
      modal: false,
      isEmpty: false
    },
    modal: false,
    isEmpty: false
  }),

  getters: {
    getBannerData(state) {
      return state;
    }
  },

  mutations: {

    resetBannerState(state) {
      Object.assign(state, state.default)
    },

    toggleBannerEmpty(state, status) {
      state.isEmpty = status ?? !state.isEmpty;
    },

    toggleBannerModal(state, status) {
      state.modal = status ?? !state.modal;
    }
  },

  actions: {
    toggleBanner(ctx, payload = null) {
      ctx.commit("toggleBannerModal", payload);
    },

    toggleEmpty(ctx, payload = null) {
      ctx.commit("toggleBannerEmpty", payload);
    },

    resetBanner(ctx) {
      ctx.commit('resetBannerState')
    }
  }
};
